exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader[data-v-54499458]{display:flex;justify-content:center;align-items:center;height:50vh;flex-direction:column}.spinner[data-v-54499458]{border:4px solid rgba(0,0,0,.1);border-left-color:#7983ff;border-radius:50%;width:50px;height:50px;animation:spin-data-v-54499458 1s linear infinite}@keyframes spin-data-v-54499458{to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54499458","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/Sso.vue
// module id = 635
// module chunks = 0